<template>
    <div class='iframe'>
        <div v-if='showBtn && iframeNum !=10' class='navigation'>
          <p :class="{extra_margin: iframeNum > 5}" @click='$parent.$parent.startOver()'>Start Over</p>
          <p v-if='iframeNum <= 4' @click='back()'>Back</p>
          <div @click='next()' class='btn fixed_btn'>
            <div>
              <p>Next Step</p>
              <img class='arr' src='@/assets/img/arr.svg'>
            </div>
          </div>
        </div>
        
        <div v-if='showBtn && iframeNum == 10'  @click='finish()' class='navigation'>
          <div class='btn fixed_btn'>
            <div>
              <p>Finish</p>
              <img class='arr' src='@/assets/img/arr.svg'>
            </div>
          </div>
        </div>
        <template v-if='data[iframeNum].multiple'>
          <iframe :src='"https://bcg-digital-room.popshap.net/"+data[iframeNum].multiple[sector]'></iframe>
        </template>
        <template v-else>
          <iframe :src='"https://bcg-digital-room.popshap.net/"+data[iframeNum].url'></iframe>
        </template>
        <div v-if='iframeNum > 5' class='links'>
          <p @click='changeSector(5)' :class="{active: iframeNum == 6}">The {{sector}} Landscape</p>
          <p @click='changeSector(6)' :class="{active: iframeNum == 7}">Value of Bionic Outcomes</p>
          <p @click='changeSector(7)' :class="{active: iframeNum == 8}">The Bionic {{sector}} Organization</p>
          <p @click='changeSector(8)' :class="{active: iframeNum == 9}">Bionic Approach</p>
          <p @click='changeSector(9)' :class="{active: iframeNum == 10}">Case Examples</p>
        </div>
        <p v-if='iframeNum < 5' class='title' :style="{borderBottom: '5px solid '+ data[iframeNum].color}">{{data[iframeNum].name}}</p>
    </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "iframe1",
  props: ['iframeNum', 'sector'],
  data(){
    return {
      showBtn: true,
      data: {
        1: {
          name: "Purpose and Strategy",
          url: 'purpose-strategy',
          color: '#465262'
        },
        2: {
          name: "Outcomes",
          url: 'outcomes',
          color: '#7a9659'
        },
        3: {
          name: "Human Enablers",
          url: 'human-enablers',
          color: '#4c8ac3'
        },
        4: {
          name: "Technology Enablers",
          url: 'tech-enablers',
          color: '#375d7b'
        },
        6: {
          name: "The Landscape",
          url: 'landscape',
          color: '#375d7b',
          multiple: {
            CPG: 'landscape',
            Healthcare: 'landscape/healthcare.html',
            Automative: 'landscape/automative.html',
            Insurance: 'landscape/insurance.html'
          }
        },
        7: {
          name: "Value of Bionic Outcomes",
          url: 'value-outcomes',
          color: '#375d7b'
        },
        8: {
          name: "The Bionic Organization",
          url: 'bionic-organization',
          color: '#375d7b'
        },
        9: {
          name: "Bionic Approach",
          url: 'bionic-approach',
          color: '#375d7b'
        },
        10: {
          name: "Case Examples",
          url: 'case-examples',
          color: '#375d7b'
        },
      }
    }
  },
  created(){
    
  },
  methods: {
    next(){
      this.showBtn = false;
      setTimeout(()=> {
        this.$parent.nextStep(this.iframeNum+1);
      }, 100);
    },
    changeSector(num){
      this.showBtn = false;
      setTimeout(()=> {
        this.$parent.changeSector(num);
      }, 100);
    },
    finish(){
      this.$parent.$parent.reset();
    },
    back(){
      if (this.iframeNum < 2) {
        this.$parent.$parent.startOver();
      }else {
        this.showBtn = false;
        setTimeout(()=> {
          this.$parent.nextStep(this.iframeNum-1);
        }, 100);
      }
    }
  }
}
</script>
